Deletes an existing webhook subscription.
